import React from 'react';
import { useRouter } from 'next/router';

const LaunchWithLuckyGo = () => {
  const router = useRouter();

  return (
    <div
      className="relative flex h-12 cursor-pointer items-center  justify-center rounded-full border border-neutral-600 px-4 md:px-6 py-3 text-base font-medium text-white hover:border-divider-dark-hovered"
      onClick={() => {
        router.push('/launchwithlucky');
      }}
    >
      Launch with us
      <div className="freeBg absolute -top-3 right-0 flex h-5 min-w-[128px] items-center justify-center rounded-full px-2 text-xs font-normal text-[#141416]">
        🚀 Free For Creators
      </div>
    </div>
  );
};

export default LaunchWithLuckyGo;
